import Image from 'next/image';

import Alert from '@/tayara-kit/Alert';
import Text from '@/tayara-kit/Text';

interface IAlert {
  title: string;
  searchParams: string[];
  viewResult: () => void;
  deleteAlert: () => void;
}

interface Props {
  alerts: IAlert[];
}

const MyAlertsTab = ({ alerts }: Props) => (
  <div className="min-h-[400px]">
    <Text
      as="h2"
      text="Mes alertes"
      className="text-2xl text-gray-600 font-bold mb-4"
    />

    <div className="flex flex-wrap w-full">
      {alerts.length > 0 ? (
        alerts.map((alert, index) => (
          <Alert
            key={index}
            title={alert.title}
            searchParams={alert.searchParams}
            viewResult={alert.viewResult}
            deleteAlert={alert.deleteAlert}
          />
        ))
      ) : (
        <div className="flex flex-col items-center mt-6 w-full  ">
          <Image
            width={600}
            height={600}
            src="/media/EmptyAlert.svg"
            alt="tayara illustration : celebrate"
            className="w-1/2 h-1/2"
          />
          <Text
            as="p"
            text="Oups ! Il semble que vous n'ayez pas encore enregistré de recherches."
            className="text-xl text-gray-800 my-4 text-center"
          />
          <Text
            as="p"
            text="Pour enregistrer une recherche, appuyez sur le button ''Sauvegarder'' lors de la recherche"
            className=" text-xl lg:text-2xl text-gray-800 font-bold my-2 text-center"
          />
        </div>
      )}
    </div>
  </div>
);

export default MyAlertsTab;
